import React from "react";

// Hidden by default: populate only with logos we have written permission to show.
const LOGOS = [];

export const CustomerLogoStrip = () => {
    if (!LOGOS.length) return null;
    return (
        <section className="max-w-7xl mx-auto px-5 sm:px-10 py-10 border-t border-border/60" data-testid="customer-logo-strip">
            <div className="mono-label mb-6">Trusted by</div>
            <div className="flex flex-wrap items-center gap-x-12 gap-y-6">
                {LOGOS.map((l) => (
                    <img key={l.name} src={l.src} alt={l.name} className="h-8 w-auto opacity-80" loading="lazy" />
                ))}
            </div>
        </section>
    );
};
